import React from 'react';
import ReportingMembershipsCurrentMembersPage from '../components/ReportingMembershipsCurrentMembersPage';

const ReportingMembershipsCurrentMembersApp = (props) => (
  <ReportingMembershipsCurrentMembersPage {...props} />
);

export default ReportingMembershipsCurrentMembersApp;
